// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1O35Q","messages":"Chat_messages__1jAQC","dateDivider":"Chat_dateDivider__18ji9"};